import * as Moment from "moment";
import { IFormFieldDefinition } from "../interfaces/Fields";

export class DefaultValueByConditionHelper {
  static setInitialValues(component, initialValues) {
    let formDefinitions: IFormFieldDefinition[] =
      component.props.formDefinitions[component.state.currentForm] || [];

    formDefinitions.forEach((formFieldDefinition) => {
      if (!formFieldDefinition.defaultValueByCondition) {
        return;
      }

      if (formFieldDefinition.defaultValueByCondition.expression !== "custom") {
        return;
      }

      if (formFieldDefinition.defaultValueByCondition.params[0] === "checkAge") {
        const result = this._ageCheck(formFieldDefinition, component.props.forms);
        if (result != null) {
          initialValues[formFieldDefinition.name] = result;
        }
      }
    });

    return initialValues;
  }

  private static _ageCheck(fieldDefinition: IFormFieldDefinition, forms): string | number | null {
    const checkForm = forms[fieldDefinition.defaultValueByCondition.form];
    if (!checkForm || !checkForm[fieldDefinition.defaultValueByCondition.control]) {
      return null;
    }

    let date = Moment(checkForm[fieldDefinition.defaultValueByCondition.control], "DD-MM-YYYY");
    if (!date.isValid()) {
      return null;
    }

    const age = Moment().diff(date, "years");
    if (fieldDefinition.defaultValueByCondition.values) {
      const newValue = fieldDefinition.defaultValueByCondition.values.find(val => {
        if (val.check === '==' && age == val.checkValue) {
          return true;
        }
        if (val.check === '<' && age < val.checkValue) {
          return true;
        }
        if (val.check === '>' && age > val.checkValue) {
          return true;
        }

        return false;
      });

      if (newValue) {
        return newValue.value;
      }
    } else if (age < fieldDefinition.defaultValueByCondition.params[1]) {
      return fieldDefinition.defaultValueByCondition.value;
    }
    
    return fieldDefinition.defaultValueByCondition.elseValue;
  }
}
